import { NotifyHelper } from "../../../helpers/toast";
import { ePhongHocActionsObj } from "../../action-types/category/IPhongHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phongHocActions = {
  ...generateActions(ePhongHocActionsObj, "PHONG_HOC"),
  ...generateActionForKey(ePhongHocActionsObj, "PHONG_HOC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(ePhongHocActionsObj, "PHONG_HOC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(ePhongHocActionsObj, "PHONG_HOC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(ePhongHocActionsObj, "PHONG_HOC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
